import { useCallback, useMemo, useState } from "react";

export const useForceRerender = () => {
  const [forceCount, setForceCount] = useState(0);
  const forceRerender = useCallback(
    () => setForceCount((count) => count + 1),
    []
  );

  return useMemo(
    () => [forceCount, forceRerender] as const,
    [forceCount, forceRerender]
  );
};
